import { render, staticRenderFns } from "./ListCook.vue?vue&type=template&id=35aac046&"
import script from "./ListCook.vue?vue&type=script&lang=js&"
export * from "./ListCook.vue?vue&type=script&lang=js&"
import style0 from "./ListCook.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports